<template>
    <div id="footer-template" class="footer">
        <div class="row justify-content-center text-center">   
             <div class="col-sm-1">
                <a href="mailto:miingjazz2131@gmail.com?Subject=Hello" target="_top">Contact</a>
            </div>
            <div class="col-sm-1">
                <a href="javascript:void(0)" @click="openModal">Rules</a>
            </div>      
            <div class="col-sm-1">
                <div class="donation-address">
                    <a href="https://explorer.nebulas.io/#/address/n1eyERuA5XTYzzb82Km9NxkCu6s9LdbGpkP" target="_blank">Contract</a>
                </div>
            </div>
        </div>
        <div class="copyright">
            HANGMAN &copy; {{ thisYear }}
        </div>
    </div>
</template>

<script type="text/javascript">
  export default {
    name: 'footer-template',
    computed: {
        thisYear () {
          return new Date().getFullYear();
        }
    },
    methods: {
      openModal () {
          console.log('here')
           this.$root.$emit('bv::show::modal','rules-modal');
      }
    }
  }
</script>

<style scoped lang="less">

@accentColor: #88929B;

.footer {
  border-top: 1px solid #ccc;
  background: #243447;
  padding-top: 50px;
  color: @accentColor;
  font-size: 14px;
  overflow: hidden;

  header {
    color: @accentColor;
    font-weight: bold;
    margin-bottom: 5px;
  }

  a {
    color: @accentColor;
  }

  .fab {
    font-size: 28px;
    margin-right: 10px;
  }

  .horizontal-list {
    list-style: none;
    padding: 0;
  }

  .donation-address {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .copyright {
    font-size: 10px;
    text-align: center;
    margin-top: 40px;
    padding: 30px 0;
    border-top: 1px solid @accentColor;
  }
}

@media only screen and (max-width: 600px) {
  .footer { 
    .col-sm-3 {
      padding: 0 30px;
    }
    .donation-address {
      font-size: 12px!important;
    }
  }  
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TheFooter.vue